import { z } from 'zod';

export const MetricChangeStatusRequest = z.object({
  status: z.string().min(1),
});

export type MetricChangeStatus = z.infer<typeof MetricChangeStatusRequest>;
